import styled, { css } from 'styled-components';

import { flexCenter } from 'styles';

export const RightContainer = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  ${({ theme }) =>
    theme.responsive.isDesktop &&
    css`
      flex: 1;
    `}
`;

export const Container = styled.div<{ withoutPadding?: boolean }>`
  gap: 16px;
  width: 100%;
  display: flex;

  ${({ theme, withoutPadding }) => css`
    flex-direction: ${theme.responsive.isDesktop ? 'row' : 'column'};
    ${!withoutPadding &&
    css`
      padding: 16px;
    `}
  `}
`;

export const RightWrap = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: ${({ theme }) =>
    theme.responsive.isMobile ? 'column' : 'row'};
  > div {
    flex: 1;
  }
`;

export const PieContainer = styled.div`
  ${flexCenter};
  gap: 16px;
  width: 100%;
  min-height: 352px;
  flex-direction: column;
`;

export const Dot = styled.div<{ bg: string }>`
  width: 12px;
  height: 12px;
  min-width: 12px;
  margin-right: 4px;
  border-radius: 50%;
  background: ${(p) => p.bg};
`;

export const DatePickerContainer = styled.div<{
  datePickerContainerPadding?: string;
}>`
  ${({ theme, datePickerContainerPadding }) => css`
    padding: ${datePickerContainerPadding ?? '16px 16px 0'};
    max-width: ${theme.responsive.isMobile ? 'unset' : 'fit-content'};
  `};

  /* Room for a full "MM/DD/YYYY - MM/DD/YYYY" value plus the calendar icon
     (the input's own width cut the last digits off). */
  input {
    min-width: 240px;
  }
`;

export const ListsContainer = styled.div`
  gap: 16px;
  display: flex;
  padding: 0 16px 16px;
  flex-direction: column;
`;
